import { Component, Input, OnInit } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from '@nomadreservations/ngx-gallery';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-img-gallery',
  templateUrl: './img-gallery.component.html',
  styleUrls: ['./img-gallery.component.scss']
})
export class ImgGalleryComponent implements OnInit {
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  @Input() images: any[];
  constructor() { }

  ngOnInit(): void {
    this.galleryImages = this.images.map((item) => {
      return { small: environment.rediImg + '/' + item.imagen, medium: environment.rediImg + '/' + item.imagen, big: environment.rediImg + '/' + item.imagen }
    })
    this.galleryOptions = [
      {
        width: '400px',
        height: '400px',
        imageAnimation: NgxGalleryAnimation.Fade,
        imageSize: 'contain',
        imageArrows: false,
        thumbnails: false,
        imageAutoPlay: true,
        imageBullets: true,
        previewArrows: false,
        previewCloseOnClick: true,
        previewCloseOnEsc: true,
        previewZoom: false,
        previewRotate: false
      },
    ];
  }

}
